import { render } from "./HomeCreed.vue?vue&type=template&id=66391152&scoped=true"
import script from "./HomeCreed.vue?vue&type=script&lang=js"
export * from "./HomeCreed.vue?vue&type=script&lang=js"

import "./HomeCreed.vue?vue&type=style&index=0&id=66391152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66391152"]])

export default __exports__